import { getSearch, push } from 'connected-react-router';
import { FC, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as IconArrow } from '../../../assets/images/arrow.svg';
import { Locale } from '../../../models/locale.model';
import { updateQueryString } from '../../../providers/location.provider';
import { AppState } from '../../../store/store';
import { storeLocale } from '../../../store/ui/selectors';

import './LanguageSwitcher.scss';

const LANGUAGES: Locale[] = ['de', 'en', 'it', 'fr'];

const LanguageSwitcher: FC = () => {
    const dispatch = useDispatch();
    const locale = useSelector(storeLocale) as Locale;
    const search = useSelector((state: AppState) => getSearch(state));
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleClose = (e: Event) => {
            if (!ref.current?.contains(e.target as Node)) {
                setOpen(false);
            }
        };

        window.addEventListener('click', handleClose);

        return () => window.removeEventListener('click', handleClose);
    }, []);

    const selectLanguage = (lang: Locale) => {
        setOpen(false);
        dispatch(push({ search: updateQueryString(search, { lang }) }));
    };

    return (
        <div className={open ? 'language-switcher active' : 'language-switcher'} ref={ref}>
            <button
                type="button"
                className="language-switcher__trigger"
                aria-haspopup="listbox"
                aria-expanded={open}
                onClick={() => setOpen(!open)}
            >
                {locale?.toUpperCase()}
                <IconArrow />
            </button>

            {open && (
                <ul className="language-switcher__dropdown" role="listbox">
                    {LANGUAGES.filter(lang => lang !== locale).map(lang => (
                        <li key={lang}>
                            <button
                                type="button"
                                role="option"
                                aria-selected={false}
                                className="language-switcher__option"
                                onClick={() => selectLanguage(lang)}
                            >
                                {lang.toUpperCase()}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default LanguageSwitcher;
